import type { IconSvgObject } from './types';

const FolderSyncIcon: IconSvgObject = [
  ["path", { d: "M8 6.49446H12.0179M12.0179 6.49446H20C21.1046 6.49446 22 7.38989 22 8.49446V10.5M12.0179 6.49446L9.60016 3.29437C9.22218 2.79407 8.63144 2.5 8.0044 2.5H4C2.89543 2.5 2 3.39543 2 4.5V18.5C2 19.6046 2.89543 20.5 4 20.5H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.4649 15C20.7733 13.8044 19.4806 13 18 13C16.4726 13 15.1451 13.8561 14.4713 15.1147M14.5351 19C15.2267 20.1956 16.5194 21 18 21C19.5227 21 20.8467 20.1492 21.5224 18.897M17 15.5H14V12.5M19 18.5H22V21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderSyncIcon;
